'use client';
import React from 'react';

import BaseButton from '1_components/Buttons/BaseButton/BaseButton';
import { useAudioStore } from 'state/sfx/audioStore';

import S from './SoundToggle.module.scss';

const SoundToggle = () => {
  const isAudioAllowed = useAudioStore(s => s.isAllowed);
  const toggleIsAudioAllowed = useAudioStore(s => s.toggleIsAllowed);

  return (
    <BaseButton
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 2, ease: 'easeInOut' }}
      className={S.button_wrapper}
      onClick={toggleIsAudioAllowed}
    >
      {isAudioAllowed ? (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M5.33611 9.83124C5.01277 9.83124 4.74463 10.0994 4.74463 10.4227V13.5773C4.74463 13.9006 5.01277 14.1688 5.33611 14.1688H7.78091L10.4386 16.8265C10.6437 17.0316 10.9039 17.0316 11.0853 16.9527C11.2588 16.8817 11.4481 16.7003 11.4481 16.4085V7.59149C11.4481 7.29969 11.2588 7.1183 11.0853 7.04733C10.9118 6.97635 10.6516 6.96846 10.4465 7.17351L7.78879 9.83124H5.33611ZM8.46703 10.8407L10.273 9.04259V14.9653L8.47491 13.1672C8.3645 13.0568 8.21466 12.9937 8.05693 12.9937H5.92759V11.0221H8.04905C8.20677 11.0221 8.35662 10.959 8.46703 10.8486V10.8407Z"
            fill="white"
          />
          <path
            d="M19.5984 11.9959C19.5984 10.8357 19.3793 9.72414 18.9412 8.67748C18.5355 7.69574 17.9432 6.79513 17.1968 6L16.3448 6.85193C16.9696 7.52535 17.4645 8.29615 17.8134 9.14807C18.1866 10.0568 18.3732 11.0223 18.3732 12.0041C18.3732 12.9858 18.1866 13.9513 17.8134 14.86C17.4645 15.712 16.9696 16.4828 16.3448 17.1562L17.1968 18.0081C17.9432 17.213 18.5274 16.3124 18.9412 15.3306C19.3712 14.284 19.5984 13.1643 19.5984 12.0122V11.9959Z"
            fill="white"
          />
          <path
            d="M16.3529 11.9959C16.3529 11.2657 16.215 10.5598 15.931 9.89452C15.6795 9.286 15.3225 8.72617 14.8844 8.23124L14 9.11562C14.3408 9.48884 14.6085 9.90264 14.8032 10.3489C15.0223 10.86 15.1359 11.4118 15.1359 11.9878C15.1359 12.5639 15.0223 13.1237 14.8032 13.6268C14.6085 14.073 14.3408 14.4868 14 14.86L14.8844 15.7444C15.3225 15.2495 15.6795 14.6897 15.931 14.0811C16.2069 13.4158 16.3529 12.7099 16.3529 11.9797V11.9959Z"
            fill="white"
          />
        </svg>
      ) : (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M17.3771 12.8276L19.4276 14.8781L20.2556 14.05L18.2052 11.9996L20.2556 9.9491L19.4276 9.12891L17.3771 11.1794L15.3266 9.12891L14.4985 9.9491L16.549 11.9996L14.4985 14.05L15.3266 14.8781L17.3771 12.8276Z"
            fill="white"
          />
          <path
            d="M5.33611 9.83124C5.01277 9.83124 4.74463 10.0994 4.74463 10.4227V13.5773C4.74463 13.9006 5.01277 14.1688 5.33611 14.1688H7.78091L10.4386 16.8265C10.6437 17.0316 10.9039 17.0316 11.0853 16.9527C11.2588 16.8817 11.4481 16.7003 11.4481 16.4085V7.59149C11.4481 7.29969 11.2588 7.1183 11.0853 7.04733C10.9118 6.97635 10.6516 6.96846 10.4465 7.17351L7.78879 9.83124H5.33611ZM8.46703 10.8407L10.273 9.04259V14.9653L8.47491 13.1672C8.3645 13.0568 8.21466 12.9937 8.05693 12.9937H5.92759V11.0221H8.04905C8.20677 11.0221 8.35662 10.959 8.46703 10.8486V10.8407Z"
            fill="white"
          />
        </svg>
      )}
    </BaseButton>
  );
};
export default SoundToggle;
